import ReactCardFlip from "react-card-flip";
import React, { useEffect, useRef, useState } from "react";
import "./exploreandchangedrawdown.scss";
import Buttons from "../../atoms/Buttons";
import Slider from "../../atoms/Range/Slider";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import { ModalOverlay } from "../../atoms/Modal";
import { useNavigate } from "react-router-dom";
import {
  addCommas,
  calculateMonthlyIncome,
  openPopup,
} from "../../helpers/helpers";
import { frequencySuffixMap } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import { formattedDate } from "../../helpers/helpers";
import LoadingSpinner from "../../atoms/Loader";

const ExploreAndChangeDrawdown = (props) => {
  const navigate = useNavigate();
  const [isFlipped, setIsFlipped] = useState({});
  const [showTaxFreePopup, setShowTaxFreePopup] = useState(false);
  const [showSummaryPopup, setShowSummaryPopup] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [taxFreeError, setTaxFreeError] = useState(false);
  const [taxFreeData, setTaxFreeData] = useState({});
  const [newTaxFreeData, setNewTaxFreeData] = useState({});
  const [chooseFlexiIncome, setChooseFlexiIncome] = useState(false);
  const [moreThan95PercentIncome, setMoreThan95PercentIncome] = useState(false);
  const [flexiAccessIncomeNewValue, setFlexiAccessIncomeNewValue] = useState(0);
  const [periodNewValue, setPeriodNewValue] = useState(0);
  const [flexiAccessIncomeIllustration, setFlexiAccessIncomeIllustration] =
    useState(false);
  const [flexiAccessIncomeConfirm, setFlexiAccessIncomeConfirm] =
    useState(false);
  const [flexiAcessCurrentIncome, setFlexiAccessCurrentIncome] = useState(0);
  const [flexiAccessDuration, setFlexiAccessDuration] = useState("");
  const popupShown = useRef(false);
  const errorShown = useRef(false);
  const [currentPriceManaged, setCurrentPriceManaged] = useState();
  const [currentPriceFutureAnnuity, setCurrentPriceFutureAnnuity] = useState();
  const [miRate, setMiRate] = useState(0);
  const [faRate, setFaRate] = useState(0);

  // prettier-ignore
  const [flexiCurrentValue, setFlexiCurrentValue] = useState();

  const [updatedFlexiObject, setUpdatedFlexiObject] = useState({});

  // prettier-ignore
  const [cardsData, setCardsData] = useState();

  const { flexiAccessFetching, flexiAccessData, flexiAccessError } =
    useSelector((state) => state.flexiAccessIncome);

  const { payoutRateFetching, payoutRateData } = useSelector(
    (state) => state.payoutRate,
  );

  const dispatch = useDispatch();

  const { manageFlexiAccessIncome, getPayoutRate } = bindActionCreators(
    actionCreators,
    dispatch,
  );

  useEffect(() => {
    if (
      popupShown.current === true &&
      flexiAccessData.isSuccess &&
      flexiAccessFetching === false
    ) {
      setFlexiAccessIncomeIllustration(false);
      setFlexiAccessIncomeConfirm(true);
      errorShown.current = false;
    } else if (popupShown.current === true) {
      errorShown.current = true;
    }
  }, [flexiAccessFetching, flexiAccessData, flexiAccessError]);

  // prettier-ignore
  useEffect(() => {
    setFlexiCurrentValue(
      props.data
        ?.filter((strategy) => strategy.category === props.category)
        ?.find((obj) => obj.strategyName === "Flexi-access")
    );
    setCardsData(
      props?.data?.filter((strategy) => strategy.category === props.category)
    );
  }, [props?.data]);

  useEffect(() => {
    if (props?.investorId) {
      if (
        Object.keys(payoutRateData).length === 0 &&
        props?.personInfo?.timeTravel?.birthDate !== undefined
      ) {
        const birthYear = new Date(
          props?.personInfo?.timeTravel?.birthDate,
        ).getFullYear();
        const retirementYear = new Date(
          props?.personInfo?.timeTravel?.retirementDate,
        ).getFullYear();
        getPayoutRate(props?.investorId, retirementYear - birthYear);
      }
    }
  }, [payoutRateData]);

  useEffect(() => {
    setMiRate(payoutRateData[0]?.payOutRates?.managed_income_95_payout_rate);
    setFaRate(payoutRateData[0]?.payOutRates?.future_annuity_75_payout_rate);
    setCurrentPriceManaged(payoutRateData[0]?.managedIncomeBuyPrice);
    setCurrentPriceFutureAnnuity(payoutRateData[0]?.futureAnnuityFundBuyPrice);
  }, [payoutRateData]);

  const TaxCard = cardsData?.find(
    (card) =>
      card.strategyName === "Tax-free cash as income" &&
      card.status === "Active",
  );

  const handleClick = (cardId) => {
    setIsFlipped((prevState) => ({
      ...prevState,
      [cardId]: !prevState[cardId],
    }));
  };

  // prettier-ignore
  const handleInputChange = (cardId, value) => {
    let flexiObject = cardsData.find(
      (strategy) =>
        strategy.strategyId === cardId &&
        strategy.strategyName !== "Flexi-access"
    );
    let fundPercentage = value.trimStart().replace(/\s+/g, "") || "0";
    if (fundPercentage !== "0") {
      fundPercentage = fundPercentage.replace(/^0+(?!\.)/, "");
    }
    const regex = /^(100|[1-9]?\d(\.\d{1,2})?|[1-9]?\d\.)$/;
    if (regex.test(fundPercentage) || fundPercentage === "") {
      setCardsData((prevCardsData) => {
        return prevCardsData.map((card) => {
          if (card.strategyId === cardId) {
            return {
              ...card,
              strategyPercentage: fundPercentage,
              newCurrentValue: (
                (parseFloat(props.totalFund) * parseFloat(value)) /
                100
              ).toFixed(2),
              newCurrentIncome:
                card.strategyName === "Flexi-access"
                  ? parseFloat(card.newCurrentIncome) !== 0
                    ? card.newCurrentIncome
                    : card.currentIncome
                  : card?.strategyName?.toLowerCase().includes("managed income")
                    ? calculateMonthlyIncome(
                        (
                          (parseFloat(props.totalFund) * parseFloat(value)) /
                          100
                        )?.toFixed(2),
                        miRate,
                        currentPriceManaged //eslint-disable-line
                      )?.toFixed(2)
                    : card?.strategyName?.toLowerCase().includes("future annuity")
                      ? calculateMonthlyIncome(
                          (
                            (parseFloat(props.totalFund) * parseFloat(value)) /
                            100
                          ).toFixed(2),
                          faRate,
                          currentPriceFutureAnnuity //eslint-disable-line
                        )?.toFixed(2)
                      : 0, //eslint-disable-line
            };
          }
          return card;
        });
      });
      props.onSliderChange(
        cardId,
        fundPercentage,
        (
          (parseFloat(props.totalFund) * parseFloat(fundPercentage)) /
          100
        ).toFixed(2),
        flexiObject
          ? flexiObject?.strategyName?.toLowerCase().includes("managed income")
            ? calculateMonthlyIncome(
                (
                  (parseFloat(props.totalFund) * parseFloat(value)) /
                  100
                ).toFixed(2),
                miRate,
                currentPriceManaged //eslint-disable-line
              ).toFixed(2)
            : flexiObject?.strategyName?.toLowerCase().includes("future annuity")
              ? calculateMonthlyIncome(
                  (
                    (parseFloat(props.totalFund) * parseFloat(value)) /
                    100
                  ).toFixed(2),
                  faRate,
                  currentPriceFutureAnnuity //eslint-disable-line
                ).toFixed(2)
              : 0
          : parseFloat(
                cardsData?.find(
                  (strategy) =>
                    strategy.strategyId === cardId &&
                    strategy.strategyName === "Flexi-access"
                )?.newCurrentIncome
              ) !== 0
            ? parseFloat(
                cardsData.find(
                  (strategy) =>
                    strategy.strategyId === cardId &&
                    strategy.strategyName === "Flexi-access"
                )?.newCurrentIncome
              )
            : cardsData.find(
                (strategy) =>
                  strategy.strategyId === cardId &&
                  strategy.strategyName === "Flexi-access"
              )?.currentIncome
      );
    }
  };

  const inputRef = useRef({});

  const handleKeyDown = (e, id) => {
    const inputIndex = cardsData?.findIndex((data) => data.strategyId === id);
    if (inputIndex === -1) return;

    const percentIndex = inputRef?.current[id]?.value?.indexOf("%");
    const cursorPos = inputRef?.current[id]?.selectionStart;

    if (cursorPos >= percentIndex) {
      e.preventDefault();
      setTimeout(() => {
        inputRef?.current[id]?.setSelectionRange(percentIndex, percentIndex);
      }, 0);
    }
  };

  // prettier-ignore
  const manageTaxFree = () => {
    const taxfree = cardsData.find(
      (strategy) => strategy.strategyName === "Tax-free cash as income"
    );
    setTaxFreeData(taxfree);
    setShowTaxFreePopup(true);
  };

  const taxFreeContinue = (obj) => {
    setNewTaxFreeData(obj);
    setShowTaxFreePopup(false);
    setShowSummaryPopup(true);
  };

  const handleContinue = () => {
    setShowTaxFreePopup(false);
    setShowSummaryPopup(false);
    if (taxFreeError !== true) {
      setShowConfirm(true);
    }
  };
  const handletfConfirmed = () => {
    let toggle = "drawdown";
    let combinedState = {
      toggle,
    };
    navigate("/manage?tab=investments", { state: combinedState });
  };

  // prettier-ignore
  const chooseFlexiIncomeChange = (e) => {
    e.preventDefault();
    const flexiAcess = cardsData?.find(
      (strategy) => strategy?.strategyName === "Flexi-access"
    );
    const frequency =
      flexiAcess?.duration === "Annual"
        ? "Annually"
        : flexiAcess?.duration === "HalfYearly"
          ? "Half yearly"
          : flexiAcess?.duration;
    setFlexiAccessCurrentIncome(flexiAcess?.currentIncome);
    setFlexiAccessDuration(frequency);
    setChooseFlexiIncome(true);
  };

  // prettier-ignore
  const chooseFlexiAcessHandleContinue = (flexiAccessIncome, period) => {
    if (
      parseFloat(flexiAccessIncome) >=
      parseFloat(flexiCurrentValue?.currentValue) * 0.95
    ) {
      setFlexiAccessIncomeNewValue(flexiAccessIncome);
      setPeriodNewValue(period);
      setChooseFlexiIncome(false);
      setMoreThan95PercentIncome(true);
    } else {
      setFlexiAccessCurrentIncome(flexiAccessIncome);
      setFlexiAccessDuration(period);
      setUpdatedFlexiObject(
        cardsData?.find(
          (strategy) => strategy?.strategyName === "Flexi-access",
        ),
      );
      setChooseFlexiIncome(false);
      setFlexiAccessIncomeIllustration(true);
    }
  };

  const handleContinueAfter95Percent = (flexiAccessIncome, period) => {
    setMoreThan95PercentIncome(false);
    setFlexiAccessCurrentIncome(flexiAccessIncome);
    setFlexiAccessDuration(period);
    setUpdatedFlexiObject(
      cardsData?.find((strategy) => strategy?.strategyName === "Flexi-access"),
    );
    setChooseFlexiIncome(false);
    setFlexiAccessIncomeIllustration(true);
  };

  const handleIllustrationContinue = () => {
    setCardsData((prevCardsData) => {
      return prevCardsData.map((card) => {
        if (card.strategyName === "Flexi-access") {
          return {
            ...card,
            currentIncome: flexiAcessCurrentIncome,
            duration: flexiAccessDuration,
          };
        }
        return card;
      });
    });
    props.onFlexiIncomeChange(flexiAcessCurrentIncome, flexiAccessDuration);
    const frequency =
      flexiAccessDuration === "Annually"
        ? "Annual"
        : flexiAccessDuration === "Half yearly"
          ? "HalfYearly"
          : flexiAccessDuration;
    const payload = {
      drawdownIncomeAmount: flexiAcessCurrentIncome,
      pensionPaymentFrequency: frequency,
      paymentDay: 5,
      flexibleIncomeAllowed: true,
      firstTime:
        parseFloat(flexiCurrentValue?.currentIncome) === 0 ? true : false,
    };
    popupShown.current = true;
    manageFlexiAccessIncome(payload, props.investorId, props.investorAccountId);
  };

  const riskRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="eac-popover-inner">
        <Popover.Body className="eac-popover-body">
          <div className="sub-title mb-2">
            It measures the relative risk and reward of an investment fund,
            where 1 being low risk and potentially low returns up to 7 high risk
            and potentially high returns.
          </div>
          <div className="sub-title mb-3">
            It’s calculated using past performance and volatility. This risk
            rating is a ‘Synthetic Risk and Reward Indicator’ (SRRI). The SRRI
            risk ratings are based on European Security and Markets Authority
            (ESMA) guidelines.
          </div>
          <div className="sub-title mb-3">
            The risk rating doesn’t guarantee how the fund will perform in the
            future, and it can change over time.
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const esgRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="eac-popover-inner">
        <Popover.Body className="eac-popover-body">
          <div className="sub-title mb-2">
            The MSCI ESG Fund Rating is designed to measure the Environmental,
            Social and Governance (ESG) characteristics of a fund’s underlying
            investment holdings.
          </div>
          <div className="sub-title mb-3">
            The ESG Rating ranges from leader (AAA, AA), average (A, BBB, BB) to
            laggard (B, CCC).
          </div>
          <div className="sub-title mb-3">
            The overall fund score is based on each individual holding’s ESG
            rating and the proportion held in this fund (and if there is
            sufficient available data to do so).
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const forIncomeTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          These drawdown options manage your income and investments for you
        </div>
      </Popover.Body>
    </Popover>
  );

  const forGrowthTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          These drawdown options aren&apos;t intended for income but you can dip
          in at any time
        </div>
      </Popover.Body>
    </Popover>
  );

  const selfManagedTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          This drawdown option enables you to choose your investments and income
        </div>
      </Popover.Body>
    </Popover>
  );

  if (payoutRateFetching) {
    return <LoadingSpinner />;
  }

  return (
    <div className="horizontal-cards-container">
      {cardsData?.length === 0 ? (
        ""
      ) : (
        <div className="managed-income-heading">
          <span className="manage-heading-text">
            {props.category}{" "}
            <OverlayTrigger
              placement="bottom"
              overlay={
                props.category === "Self-managed"
                  ? selfManagedTooltip
                  : props.category === "For Growth"
                    ? forGrowthTooltip
                    : props.category === "For Income"
                      ? forIncomeTooltip
                      : ""
              }
              flip={true}
            >
              <span className="manage-heading-icon-margin">
                <Icons iconname="tool-tip" variant="icon-sixteen-px" />
              </span>
            </OverlayTrigger>
          </span>
        </div>
      )}
      {cardsData &&
        cardsData?.map((card) => (
          <>
            <ReactCardFlip
              key={card.strategyId}
              isFlipped={isFlipped[card.strategyId] || false}
              flipDirection="horizontal"
            >
              {card.strategyName !== "Tax-free cash as income" &&
              card.strategyName !== "enable-flexi-access" &&
              card.strategyName !== "disable-flexi-access" ? (
                <div
                  className="investment-card"
                  key={`front-${card.strategyId}`}
                >
                  <div className="card-front">
                    <div className="fund-name">
                      <span
                        className="circle"
                        style={{ backgroundColor: card.color }}
                      ></span>
                      {["safety", "safety net", "safety net fund"].includes(
                        (card?.strategyName || "").toLowerCase().trim(),
                      )
                        ? "Safety net"
                        : ["legacy", "legacy fund"].includes(
                              (card?.strategyName || "").toLowerCase().trim(),
                            )
                          ? "Legacy"
                          : card?.strategyName}
                    </div>
                    <hr className="upper-line" />
                    <div className="parent-value">
                      <span className="current-value-text">Current value</span>
                      <span className="current-value">
                        £{addCommas(Math.trunc(card.currentValue))}.
                        <span className="eac-pot-value-small-digit">
                          {(card.currentValue % 1).toFixed(2).substring(2)}
                        </span>
                      </span>
                    </div>
                    {card.strategyName === "Safety" ||
                    card.strategyName === "Safety net" ||
                    card.strategyName === "Legacy" ||
                    card.strategyName === "Safety Net Fund" ||
                    card.strategyName === "Legacy Fund" ||
                    card.strategyName === "Flexi-access" ? (
                      ""
                    ) : (
                      <div className="parent-value">
                        <span className="current-value-text">
                          Current income
                        </span>
                        <span className="current-value">
                          £{addCommas(Math.trunc(card.currentIncome))}.
                          <span className="eac-pot-value-small-digit">
                            {(card.currentIncome % 1).toFixed(2).substring(2)}
                          </span>
                          p/m
                        </span>
                      </div>
                    )}
                    <hr className="lower-line" />
                    <div className="fund-text mb-3">
                      {card.strategyName === "Flexi-access"
                        ? "A fully flexible option where you decide the funds you’d like to invest, when you take out money and how much."
                        : card.shortDesc}
                    </div>
                    <div className="slider-dd">
                      <Row>
                        <Col xl={10} xs={10} sm={10} lg={10} md={10}>
                          <Slider
                            onChange={(e) =>
                              handleInputChange(card.strategyId, e.target.value)
                            }
                            value={card.strategyPercentage}
                            minValue="0"
                            maxValue="100"
                            step="1"
                            className="change-investment-slider"
                          />
                        </Col>
                        <Col
                          xl={2}
                          xs={2}
                          sm={2}
                          lg={2}
                          md={2}
                          className="input-text-col"
                        >
                          <input
                            type="text"
                            ref={(el) =>
                              (inputRef.current[card.strategyId] = el)
                            }
                            className="input-text"
                            value={`${
                              parseFloat(card?.strategyPercentage) === 100
                                ? "100"
                                : card?.strategyPercentage
                            }%`}
                            onChange={(e) =>
                              handleInputChange(
                                card.strategyId,
                                e.target.value.replace("%", "") //eslint-disable-line
                              )
                            }
                            onKeyUp={(e) =>
                              handleKeyDown(
                                e,
                                card.strategyId //eslint-disable-line
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                    <hr className="new-upper-line" />
                    <div className="parent-value">
                      <span className="current-value-text">New value</span>
                      <span className="current-value">
                        £
                        {isNaN(card.newCurrentValue) ? (
                          ""
                        ) : (
                          <>
                            {addCommas(Math.trunc(card.newCurrentValue))}.
                            <span className="eac-pot-value-small-digit">
                              {(card.newCurrentValue % 1)
                                .toFixed(2)
                                .substring(2)}
                            </span>{" "}
                          </>
                        )}
                      </span>
                    </div>
                    {card.strategyName === "Safety" ||
                    card.strategyName === "Safety net" ||
                    card.strategyName === "Legacy" ||
                    card.strategyName === "Safety Net Fund" ||
                    card.strategyName === "Legacy Fund" ||
                    card.strategyName === "Flexi-access" ? (
                      ""
                    ) : (
                      <div className="parent-value">
                        <span className="current-value-text">New income</span>
                        <span className="current-value">
                          £
                          {isNaN(card.newCurrentIncome) ? (
                            ""
                          ) : (
                            <>
                              {addCommas(Math.trunc(card.newCurrentIncome))}.
                              <span className="eac-pot-value-small-digit">
                                {(card.newCurrentIncome % 1)
                                  .toFixed(2)
                                  .substring(2)}
                              </span>
                              p/m{" "}
                            </>
                          )}
                        </span>
                      </div>
                    )}
                    <hr className="new-lower-line" />
                    <div
                      className={
                        card.strategyName === "Safety net" ||
                        card.strategyName === "Legacy"
                          ? "safety-legacy-button-align"
                          : card.strategyName === "Flexi-access"
                            ? "button-align-fa"
                            : "button-align"
                      }
                    >
                      {card.strategyName === "Flexi-access" ? (
                        ""
                      ) : (
                        <div className="view-fund-button">
                          <Buttons
                            name="View full fund fact sheet"
                            className="tertiary"
                            handleClick={() =>
                              openPopup(
                                card.mediaUrl !== undefined
                                  ? card.mediaUrl
                                  : card.pDFUrl //eslint-disable-line
                              )
                            }
                          ></Buttons>
                        </div>
                      )}
                      {card.strategyName === "Flexi-access" ? (
                        <div>
                          {card.currentValue === 0 ? (
                            <Buttons
                              name="Manage"
                              className="secondary"
                              disabled={true}
                            ></Buttons>
                          ) : (
                            <Buttons
                              name="Manage"
                              className="secondary"
                              handleClick={() =>
                                props.handleFlexiAccessContinue(true)
                              }
                            ></Buttons>
                          )}
                        </div>
                      ) : (
                        <Buttons
                          name="See overview"
                          className="secondary"
                          handleClick={() => handleClick(card.strategyId)}
                        ></Buttons>
                      )}
                    </div>
                  </div>
                </div>
              ) : card.strategyName === "enable-flexi-access" ? (
                <div
                  className="unlocked-flexi-card"
                  key={`front-${card.strategyId}`}
                >
                  <div className="flexi-card-front">
                    <div className="manage-flexi-text">Flexi-access income</div>
                    <hr className="upper-line" />
                    <div className="manage-flexi--access">
                      <span className="current-value-text">Current income</span>
                      <span className="current-value">
                        £{addCommas(Math.trunc(card.currentIncome))}.
                        <span className="eac-pot-value-small-digit">
                          {(card.currentIncome % 1).toFixed(2).substring(2)}
                        </span>{" "}
                        {card.duration === "Monthly"
                          ? "p/m"
                          : card.duration === "Quarterly"
                            ? "p/q"
                            : card.duration === "HalfYearly"
                              ? "p/6m"
                              : card.duration === "Annual"
                                ? "p/y"
                                : ""}
                      </span>
                    </div>
                    <hr className="lower-line" />
                    <div className="flexi-manage-btn">
                      <Buttons
                        name="Manage"
                        className="secondary"
                        handleClick={chooseFlexiIncomeChange}
                      ></Buttons>{" "}
                    </div>
                  </div>
                </div>
              ) : card.strategyName === "disable-flexi-access" ? (
                <div
                  className="locked-flexi-card"
                  key={`front-${card.strategyId}`}
                >
                  <div className="flexi-card-front">
                    <div>
                      <Icons iconname="locked" variant="icon-twenty-four-px" />
                    </div>
                    <div className="manage-flexi-text">
                      Manage Flexi-access income
                    </div>
                    <div className="manage-flexi--access">
                      You can manage Flexi-access income when you have
                      Flexi-access investments.
                    </div>
                  </div>
                </div>
              ) : card.strategyName === "Tax-free cash as income" &&
                card.status === "Active" ? (
                <div
                  className={`${
                    card.taxFreeCash ? "investment-card" : "greyed-out"
                  }`}
                  key={`front-${card.strategyId}`}
                >
                  <div className="card-front">
                    <div className="fund-name">{card.strategyName}</div>
                    <hr className="upper-line" />
                    <div className="tax-free-parent-value">
                      <span className="tax-free-current-value-text">
                        Taking as tax-free cash
                      </span>
                      <span className="tax-free-current-value">
                        £
                        {card.taxFreeCash
                          ? card.taxFreeCash +
                              " " +
                              frequencySuffixMap[card.frequency] || ""
                          : ""}
                      </span>
                    </div>
                    <div className="tax-free-parent-value">
                      <span className="tax-free-current-value-text">
                        Moving to drawdown per payment
                      </span>
                      <span className="tax-free-current-value">
                        £{card?.perPayment ? card?.perPayment?.toFixed(2) : ""}
                      </span>
                    </div>
                    <div className="tax-free-parent-value">
                      <span className="tax-free-current-value-text">Until</span>
                      <span className="tax-free-current-value">
                        {card?.dateUntil
                          ? formattedDate(card?.dateUntil)
                          : "DD/MM/YYYY"}
                      </span>
                    </div>
                    <hr className="lower-line" />
                    <div className="tax-free-button-align">
                      <Buttons
                        name="Manage"
                        className="secondary"
                        handleClick={manageTaxFree}
                        disabled={!card.taxFreeCash}
                      ></Buttons>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div
                className="back-investment-card"
                key={`back-${card.strategyId}`}
              >
                <div className="card-back">
                  <div className="fund-name">
                    <span
                      className="circle"
                      style={{ backgroundColor: card.color }}
                    ></span>
                    {card.strategyName}
                  </div>
                  <div>
                    <Row className="managed-by-text">
                      <Col>
                        <div className="managed-parent-text">
                          <span className="left-text">Managed by</span>
                          <span className="right-text">{card.managedBy}</span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="managed-by-text">
                      <Col>
                        <div className="managed-parent-text">
                          <span className="left-text">Fund charge</span>
                          <span className="right-text">{card.fundCharge}</span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="managed-by-text">
                      <Col>
                        <div className="managed-parent-text">
                          <span className="left-text">
                            Risk rating
                            <OverlayTrigger
                              placement="bottom"
                              overlay={riskRatingToolTip(card.strategyId)}
                              flip={true}
                            >
                              <span className="risk-rating-icon-margin">
                                <Icons
                                  iconname="tool-tip"
                                  variant="icon-sixteen-px"
                                />
                              </span>
                            </OverlayTrigger>
                          </span>
                          <span className="right-text">{card.riskRating}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="Average-text">
                    <span className="left-text">
                      Average ESG Rating
                      <OverlayTrigger
                        placement="bottom"
                        overlay={esgRatingToolTip(card.strategyId)}
                        flip={true}
                      >
                        <span className="risk-rating-icon-margin">
                          <Icons
                            iconname="tool-tip"
                            variant="icon-sixteen-px"
                          />
                        </span>
                      </OverlayTrigger>
                    </span>
                  </div>
                  <div className="parent-rating-box">
                    <span
                      className={
                        card.ESGRating === "CCC"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      CCC
                    </span>
                    <span
                      className={
                        card.ESGRating === "B"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      B
                    </span>
                    <span
                      className={
                        card.ESGRating === "BB"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      BB
                    </span>
                    <span
                      className={
                        card.ESGRating === "BBB"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      BBB
                    </span>
                    <span
                      className={
                        card.ESGRating === "A"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      A
                    </span>
                    <span
                      className={
                        card.ESGRating === "AA"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      AA
                    </span>
                    <span
                      className={
                        card.ESGRating === "AAA"
                          ? "colored-rating-box"
                          : "rating-box"
                      }
                    >
                      AAA
                    </span>
                  </div>
                  <div className="button-align">
                    <div className="view-fund-button">
                      <Buttons
                        name="View full fund fact sheet"
                        className="tertiary"
                        handleClick={() =>
                          openPopup(
                            card.mediaUrl !== undefined
                              ? card.mediaUrl
                              : card.pDFUrl //eslint-disable-line
                          )
                        }
                      ></Buttons>
                    </div>
                    <Buttons
                      name="Close overview"
                      className="secondary"
                      handleClick={() => handleClick(card.strategyId)}
                    ></Buttons>
                  </div>
                </div>
              </div>
            </ReactCardFlip>
          </>
        ))}
      <ModalOverlay
        popup="manageTaxFree"
        show={showTaxFreePopup}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setShowTaxFreePopup(false);
        }}
        cardsData={TaxCard}
        taxFreeContinue={taxFreeContinue}
        investorId={props.investorId}
        totalFund={parseFloat(props.totalFund).toFixed(2)}
        investorAccountId={props.investorAccountId}
        modaltitle="Manage tax free cash as income"
      />

      <ModalOverlay
        popup="taxFreeSummaryOfChanges"
        show={showSummaryPopup}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setShowSummaryPopup(false);
        }}
        setTaxFreeError={setTaxFreeError}
        taxFreeError={taxFreeError}
        taxFreeData={taxFreeData}
        investorId={props.investorId}
        investorAccountId={props.investorAccountId}
        newTaxFreeData={newTaxFreeData}
        handleContinue={handleContinue}
        handleContinueStop={handleContinue}
        isConfirm={false}
        modaltitle="Summary of changes"
      />

      <ModalOverlay
        popup="tfchangesConfirmed"
        show={showConfirm}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setShowConfirm(false);
        }}
        handleContinue={handletfConfirmed}
        isConfirm={true}
        modaltitle="Change request received"
      />

      <ModalOverlay
        popup="chooseFlexiAccessIncome"
        show={chooseFlexiIncome}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setFlexiAccessCurrentIncome(0);
          setFlexiAccessDuration("Monthly");
          setChooseFlexiIncome(false);
        }}
        modaltitle="Choose flexi-access income"
        flexiAccessCurrentIncome={flexiAcessCurrentIncome}
        flexiAccessDuration={flexiAccessDuration}
        handleFlexiAccessContinue={chooseFlexiAcessHandleContinue}
        currentValue={flexiCurrentValue?.currentValue}
        isCancel={true}
      />

      <ModalOverlay
        popup="flexiAccessIncomeIllustration"
        show={flexiAccessIncomeIllustration}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setFlexiAccessCurrentIncome(0);
          setFlexiAccessDuration("Monthly");
          setFlexiAccessIncomeIllustration(false);
        }}
        flexiAccessCurrentIncome={flexiAcessCurrentIncome}
        initialFlexiObject={flexiCurrentValue}
        updatedFlexiObject={updatedFlexiObject}
        flexiAccessDuration={flexiAccessDuration}
        modaltitle="Flexi-access income illustration"
        handleIllustrationContinue={handleIllustrationContinue}
        flexiAccessFetching={flexiAccessFetching}
        flexiAccessError={flexiAccessError}
        errorShown={errorShown.current}
      />
      <ModalOverlay
        popup="flexiAccessIncomeConfirm"
        show={flexiAccessIncomeConfirm}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setFlexiAccessIncomeConfirm(false);
        }}
        modaltitle="Flexi-access income updated"
        handleContinue={handletfConfirmed}
      />
      <ModalOverlay
        popup="moreThan95PercentIncome"
        show={moreThan95PercentIncome}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setMoreThan95PercentIncome(false);
        }}
        modaltitle="Notification"
        flexiAccessIncomeNewValue={flexiAccessIncomeNewValue}
        periodNewValue={periodNewValue}
        handleFlexiAccessContinue={handleContinueAfter95Percent}
      />
    </div>
  );
};

export default ExploreAndChangeDrawdown;
